import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { AppCard, AppModal, AppNoInfo } from "@/layout/AppComponents";
import axios from "axios";
import styled from "styled-components";
import { axiosPath } from "../../../../routing/helpers/router";
import { statusSteps } from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/constants/options";
import CommunicationPipelineStatusTimeLine from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineStatusTimeLine";
import CommunicationPipelineUserNavbar from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/User/CommunicationPipelineUserNavbar";
import CommunicationPipelineLogin from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineLogin";
import { useSelector } from "react-redux";
import errorHandler from "@/layout/components/error/ErrorHandler";
import CommunicationPipelineModuleSidebar from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineModuleSidebar";
import * as currentPageAction from "../../../../store/actions/currentPageAction";

export default function CommunicationPipelineAdminReportStatusScreen() {
  const { moduleBridgeHex, reportHex } = useParams();
  const dispatch = useDispatch();
  const [report, setReport] = useState();
  const authReports = useSelector((state) => state.currentPage?.reports) || [];
  const [isAuth, setIsAuth] = useState(false);
  const moduleData = useSelector((state) => state.currentPage?.moduleData);

  const loadReport = useCallback(async () => {
    axios
      .post(axiosPath("api_r_user_module_communicationPipeline_report_get"), {
        moduleBridgeHex,
        reportHex,
      })
      .then((r) => {
        setReport(r?.data);
      })
      .catch((e) => dispatch(errorHandler(e)));
  }, [moduleBridgeHex, reportHex]);

  const getStepDescription = useCallback(
    (step) => {
      const index = statusSteps.findIndex(
        (statusStep) => statusStep.value === step,
      );

      return (
        <>
          <h6>{statusSteps[index]?.label}</h6>
          <div>{statusSteps[index]?.description}</div>
        </>
      );
    },
    [report],
  );

  useEffect(() => {
    if (reportHex && authReports.includes(reportHex)) {
      setIsAuth(true);
    }
  }, []);

  useEffect(() => {
    loadReport();
  }, []);

  // > LOAD MODULE DATA //
  useEffect(() => {
    axios
      .post(
        axiosPath("api_r_user_module_communicationPipeline_getModuleData"),
        { moduleBridgeHex },
      )
      .then((r) => {
        dispatch(currentPageAction.change("moduleData", r.data, true));
      });
  }, []);
  // > LOAD MODULE DATA //

  if (!moduleData) return <AppNoInfo />;

  if (isAuth === false) {
    return (
      <>
        {moduleData?.permissionLevel === 0 && (
          <CommunicationPipelineModuleSidebar />
        )}
        <AppModal show={isAuth === false} isCloseButton={false}>
          <CommunicationPipelineLogin onAuth={() => setIsAuth(true)} />
        </AppModal>
      </>
    );
  }
  return (
    <>
      {moduleData?.permissionLevel === 0 && (
        <CommunicationPipelineModuleSidebar />
      )}
      <Container>
        <CommunicationPipelineUserNavbar />
        {report && (
          <AppCard className="mb-1">
            <div className="mt-5">
              <div className="row">
                <div className="col-lg-12">
                  <CommunicationPipelineStatusTimeLine report={report} />
                  <div className="alert alert-info mt-5">
                    {getStepDescription(report?.status?.step)}
                  </div>
                </div>
              </div>
            </div>
          </AppCard>
        )}
      </Container>
    </>
  );
}

const Container = styled.div`
  padding-left: 0.5rem !important;
  padding-bottom: 100px;
  h3 {
    font-size: 14px;
    font-weight: 700;
    margin: 32px 0 0 0;
  }
  .user-info {
    border: 1px solid lightgray;
    padding: 24px;
  }
`;
